module.exports = __webpack_public_path__ + "static/2front-branding-2-4a5f489b0b9d88c5686cc630582742ca.png";